import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

/**
 * The two glyphs the published header draws inline rather than fetching, kept
 * inline here for the same reason: both take their colour from the control
 * around them, which a vendored file cannot do.
 */

/** The disclosure chevron; the published viewBox is 15×14, not square. */
export function ChevronIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 14">
      <path
        d="M4 5.83337L7.5 9.33337L11 5.83337"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

/** The "leaves this page" arrow on the Compare Products banner. */
export function LaunchIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 5L5 15" />
        <path d="M6.6665 5H14.9998V13.3333" />
      </g>
    </SvgIcon>
  );
}
